import { breakpoints } from "@authentic/loyalty-pwa/util/variables";
import styled from "styled-components";

export const AboutProgramStyled = styled.div<{ bgColor?: string }>`
  font-family: Nunito Sans;
  max-width: 1127px;
  margin: 0 auto;
  padding: 24px 0;
  background-color: ${(props) => props.bgColor};
  h2 {
    font-weight: normal;
    font-size: 16px;
    text-transform: uppercase;
    font-weight: 800;
    text-align: center;
    margin-top: 32px;
  }

  > p {
    padding: 0 12px;
    text-align: center;
    max-width: 549px;
    margin: 0 auto;
  }

  @media screen and (max-width: ${breakpoints.sm}) {
    background-color: #f2f2f2;
  }
`;

export const StepsContentStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: ${breakpoints.md}) {
    flex-wrap: wrap;
    > div {
      flex: 0 0 33.33%;
    }
  }

  @media screen and (max-width: ${breakpoints.sm}) {
    > div {
      flex: 0 0 100%;
    }
  }
`;

export const StatusOveriewContentStyled = styled.div`
  background-color: white;
`;

export const TierPointsContentStyled = styled.div`
  margin-top: 42px;

  > div:nth-child(1) ul li > div {
    width: 100px;
    flex: 0 0 100px;
  }

  .tier-info {
    height: 439px;
  }

  .swiper-container {
    @media screen and (max-width: 769px) {
      overflow: hidden !important;
    }
  }

  .swiper-slide:nth-child(3) {
    .number {
      letter-spacing: -9px;
      padding: 4px 0px;
    }
  }

  @media screen and (max-width: ${breakpoints.sm}) {
    .tier-info {
      padding: 32px 24px;
      height: 450px;
      margin-left: 2px;
      margin-right: 2px;
    }
    .swiper-global-container {
      padding: 0 0 0 13px;
      .swiper-slide {
        width: 293px !important;
      }
    }
  }
`;

export const AboutProgramFooter = styled.div`
  text-align: center;
  border-top: 1px solid #9D9D9D;
  background-color: white;
  padding: 32px 0;
  margin-bottom: -32px;
  a {
    padding: 0 12px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 18px;
    text-align: center;
    letter-spacing: 0.02em;
    text-decoration: underline;
  }
`;
